"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InjectedConnector = void 0;
const tslib_1 = require("tslib");
const injected_connector_1 = require("@web3-react/injected-connector");
const types_1 = require("../types");
const UNLOCK_WALLET_TIMEOUT = 60 * 1000; // 60 seconds
class InjectedConnector extends injected_connector_1.InjectedConnector {
    constructor(chainId) {
        super({
            supportedChainIds: [chainId]
        });
    }
    activate() {
        const _super = Object.create(null, {
            activate: { get: () => super.activate }
        });
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            // Set a timeout to reject the promise if the wallet is not unlocked
            const timeoutPromise = new Promise((_, reject) => {
                setTimeout(() => {
                    reject(new types_1.ErrorUnlockingWallet());
                }, UNLOCK_WALLET_TIMEOUT);
            });
            const activatePromise = _super.activate.call(this);
            return Promise.race([activatePromise, timeoutPromise]);
        });
    }
}
exports.InjectedConnector = InjectedConnector;
//# sourceMappingURL=InjectedConnector.js.map